
import React, { useState } from 'react';
import { Outlet, Link } from "react-router-dom";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,

  Collapse,
} from "@mui/material";
import { ExpandLess, ExpandMore } from '@mui/icons-material';

const drawerWidth = 240;

function Admin() {
  const [openConfig, setOpenConfig] = useState(false);
  const [openJob, setOpenJob] = useState(false);
  
  const handleConfigClick = () => {
    setOpenConfig(!openConfig);
  };
  const handleJobClick = () => {
    setOpenJob(!openJob);
  };
  return (
    <Box sx={{ display: "flex", margin: '0px' }}>
      {/* Sidebar */}
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', marginTop: '64px' },
        }}
      >
        <List>
          <ListItem button component={Link} to="/admin/users">
            <ListItemText primary="New station" />
          </ListItem>
          <ListItem button component={Link} to="/admin/logs">
            <ListItemText primary="Provision device" />
          </ListItem>
          <ListItem button component={Link} to="/admin/Provision">
            <ListItemText primary="Provision Status" />
          </ListItem>
          <ListItem button component={Link} to="/admin/settings">
            <ListItemText primary="Device track section permission" />
          </ListItem>

          {/* Manage Device Configuration */}
          <ListItem button onClick={handleConfigClick}>
            <ListItemText primary="Manage Device Configuration" />
            {openConfig ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openConfig} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button component={Link} to="/admin/device-config/new" sx={{ pl: 4 }}>
                <ListItemText primary="New Add Config" />
              </ListItem>
              <ListItem button component={Link} to="/admin/device-config/edit" sx={{ pl: 4 }}>
                <ListItemText primary="Edit Config" />
              </ListItem>
            </List>
          </Collapse>
   {/* Manage Device Job */}
  <ListItem button onClick={handleJobClick}>
    <ListItemText primary="Manage Device Job" />
    {openJob ? <ExpandLess /> : <ExpandMore />}
  </ListItem>

  <Collapse in={openJob} timeout="auto" unmountOnExit>
    <List component="div" disablePadding>
      <ListItem button component={Link} to="/admin/device-config/job-new" sx={{ pl: 4 }}>
        <ListItemText primary="New Device Job" />
      </ListItem>
      <ListItem button component={Link} to="/admin/device-config/status" sx={{ pl: 4 }}>
        <ListItemText primary="Job Status" />
      </ListItem>
    </List>
  </Collapse>


        </List>
      </Drawer>

      {/* Content Area */}
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Outlet /> {/* Nested routes render here */}
      </Box>
    </Box>
  );
}

export default Admin;
